<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="search row"></div>
      <div class="row">
        <div class="col">
          <div class="card shadow bg-secondary">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
                    ข้อมูลใบเสร็จ
                  </h3>
                </div>
                <div class="col text-right">
                  <base-button type="primary" size="sm" @click="saveReceipt"
                    >บันทึก</base-button
                  >
                  <!-- <base-button type="danger" size="sm" @click="deleteReceipt"
                    >ลบ</base-button
                  > -->
                </div>
              </div>
            </div>

            <div class="card-body pt-0 pt-md-4">
              <div class="row mx-2 mb-3 mt-md-0 mt-3">
                <base-radio name="car" v-model="model.car_type">
                  รถยนต์
                </base-radio>

                <base-radio
                  name="motorcycle"
                  class="ml-4"
                  v-model="model.car_type"
                >
                  มอเตอร์ไซต์
                </base-radio>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <base-input
                    alternative=""
                    label="ชื่อ-สกุล"
                    placeholder="ชื่อ-สกุล"
                    input-classes="form-control-alternative"
                    v-model="model.name"
                  />
                </div>
                <div class="col-md-4">
                  <base-input
                    alternative=""
                    label="เบอร์โทรศัพท์"
                    placeholder="เบอร์โทรศัพท์"
                    type="tel"
                    maxLength="10"
                    input-classes="form-control-alternative"
                    v-model="model.tel"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-2 col-12">
                  <h4>ประเภทของเบี้ยประกัน</h4>
                  <div class="dropdown">
                    <b-dropdown
                      id="dropdown"
                      offset="100"
                      class="m-0 mr-2"
                      :text="model.insurance_type_name"
                    >
                      <b-dropdown-item
                        v-for="insuranceType in masterInsuranceType"
                        :key="insuranceType.id"
                        :value="insuranceType.name"
                        @click="
                          selectInsuranceType(
                            insuranceType.id,
                            insuranceType.name
                          )
                        "
                        >{{ insuranceType.name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <div class="col-md-3 col-12">
                  <h4>บริษัท</h4>
                  <div class="dropdown">
                    <b-dropdown
                      id="dropdown"
                      offset="100"
                      class="m-0 mr-2"
                      :text="model.insurance_company_fullname"
                      :disabled="model.insurance_type === 1"
                    >
                      <b-dropdown-item
                        v-for="insuranceCompany in masterInsuranceCompany"
                        :key="insuranceCompany.id"
                        :value="insuranceCompany.name"
                        @click="
                          selectInsuranceCompany(
                            insuranceCompany.id,
                            insuranceCompany.name,
                            insuranceCompany.fullname
                          )
                        "
                        >{{ insuranceCompany.fullname }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <div class="col-md-2 col-12">
                  <h4>ยี่ห้อรถ</h4>
                  <div class="dropdown">
                    <b-dropdown
                      id="dropdown"
                      offset="100"
                      class="m-0 mr-2"
                      :text="model.brand_name"
                      :disabled="model.car_type !== 'car'"
                    >
                      <b-dropdown-item
                        v-for="brand in masterBrand"
                        :key="brand.id"
                        :value="brand.name"
                        @click="selectBrand(brand.id, brand.name)"
                        >{{ brand.name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div>
                </div>
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="เลขทะเบียน"
                    placeholder="เลขทะเบียน"
                    input-classes="form-control-alternative"
                    v-model="model.license_plate"
                  />
                </div>
                <div class="col-md-2 col-12">
                  <h4>จังหวัด</h4>
                  <v-select
                    v-model="model.license_plate_province"
                    :options="masterProvince"
                    :reduce="(p) => p.id"
                    label="name"
                  ></v-select>
                  <!-- <div class="dropdown">
                    <b-dropdown
                      id="dropdown"
                      offset="100"
                      :text="
                        selectedLicensePlateProvince !== -1
                          ? masterProvince[selectedLicensePlateProvince].name
                          : '-- กรุณาเลือก --'
                      "
                      class="m-0 mr-2"
                    >
                      <b-dropdown-item
                        v-for="(province, index) in masterProvince"
                        :key="province.id"
                        :value="province.name"
                        @click="selectLicensePlateProvince(province.id, index)"
                        >{{ province.name }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </div> -->
                </div>
                <!-- <div class="col-md-4 mt-2 mt-md-0">
                  <base-input
                    alternative=""
                    label="บริษัทประกันอื่นๆ"
                    placeholder="ถ้ามี"
                    :disabled="model.insurance_company_name !== 'OTHER'"
                    input-classes="form-control-alternative"
                    v-model="model.if_other_insurance_company"
                  />
                </div> -->
              </div>
              <div class="row mt-3">
                <div class="col-md-3 col-12">
                  <base-input
                    alternative=""
                    label="จำนวนเงินประกัน"
                    type="number"
                    step="any"
                    placeholder="จำนวนเงินประกัน"
                    input-classes="form-control-alternative"
                    v-model="model.insurance_price"
                    :disabled="model.insurance_type === 1"
                  />
                </div>
                <div class="col-md-3 col-12">
                  <base-input
                    alternative=""
                    label="จำนวนเงิน พรบ."
                    type="number"
                    step="any"
                    placeholder="จำนวนเงิน พรบ."
                    input-classes="form-control-alternative"
                    v-model="model.wsu_price"
                  />
                </div>
                <div class="col-md-3 col-12">
                  <base-input
                    alternative=""
                    label="จำนวนเงินต่อภาษี"
                    type="number"
                    step="any"
                    placeholder="จำนวนเงินต่อภาษี"
                    input-classes="form-control-alternative"
                    v-model="model.tax_price"
                  />
                </div>
                <div class="col-md-2">
                  <base-checkbox
                    class="mt-md-5 mt-0"
                    v-model="model.is_inspected"
                  >
                    ตรวจสภาพ
                  </base-checkbox>
                </div>
              </div>
              <h6 class="heading-small text-muted mt-4 mt-md-2">
                อื่นๆ
              </h6>
              <div class="row">
                <div class="col-md-3 col-12">
                  <base-input
                    alternative=""
                    label="รายการ"
                    placeholder="รายการ"
                    input-classes="form-control-alternative"
                    v-model="model.other"
                  />
                </div>
                <div class="col-md-3 col-12">
                  <base-input
                    alternative=""
                    label="จำนวนเงิน"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="model.other_price"
                    :disabled="model.other === ''"
                  />
                </div>
                <div class="col-md-3 col-12">
                  <label for="total" class="form-control-label"
                    >ยอดเรียกเก็บ</label
                  >
                  <h4 class="heading-small text-muted mt-2">
                    {{
                      calculateTotal
                        ? Number(calculateTotal).toLocaleString()
                        : 0
                    }}
                  </h4>
                </div>
                <div class="col-md-3 col-12">
                  <base-input
                    alternative=""
                    label="ยอดจ่ายจริง"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="model.real_price"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <base-checkbox class="mt-2" v-model="model.is_installment">
                    ลูกค้าผ่อน
                  </base-checkbox>
                </div>
              </div>
              <div
                class="row mt-4"
                :class="!model.is_installment ? 'none' : ''"
              >
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="งวดที่ 1"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="model.installment_1_price"
                    :disabled="!!model.paid_1"
                  />
                </div>
                <div class="col-md-1 col-12">
                  <base-checkbox class="mt-md-5 mt-0" v-model="model.paid_1">
                    จ่ายแล้ว
                  </base-checkbox>
                </div>
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="งวดที่ 2"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="model.installment_2_price"
                    :disabled="!!model.paid_2"
                  />
                </div>
                <div class="col-md-1 col-12">
                  <base-checkbox class="mt-md-5 mt-0" v-model="model.paid_2">
                    จ่ายแล้ว
                  </base-checkbox>
                </div>
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="งวดที่ 3"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="model.installment_3_price"
                    :disabled="!!model.paid_3"
                  />
                </div>
                <div class="col-md-1 col-12">
                  <base-checkbox class="mt-md-5 mt-0" v-model="model.paid_3">
                    จ่ายแล้ว
                  </base-checkbox>
                </div>
                <div class="col-md-3 col-12">
                  <label for="total" class="form-control-label"
                    >ยอดผ่อนรวม 3 งวด</label
                  >
                  <h4 class="heading-small text-muted mt-2">
                    {{
                      calculateInstallment
                        ? Number(calculateInstallment).toLocaleString()
                        : 0
                    }}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import router from "../router";
import Dropdown from "bootstrap-vue/src/components/dropdown";
import axios from "axios";
import kickMixin from "../mixins/kickMixin";

Vue.use(Dropdown);

export default {
  name: "receipt",
  mixins: [kickMixin],
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      masterInsuranceType: [],
      masterInsuranceCompany: [],
      masterBrand: [],
      masterProvince: [],
      selectedLicensePlateProvince: -1,
      model: {
        car_type: "",
        name: "",
        tel: "",
        insurance_type: 1,
        insurance_type_name: "",
        insurance_company: 1,
        insurance_company_name: "",
        insurance_company_fullname: "",
        if_other_insurance_company: "",
        brand: 1,
        brand_name: "",
        document_type: 1,
        license_plate: "",
        license_plate_province: -1,
        wsu_price: "",
        insurance_price: "",
        tax_price: "",
        other: "",
        other_price: "",
        real_price: "",
        created_by: -1,
        created_by_name: "",
        is_inspected: false,
        is_installment: false,
        installment_1_price: "",
        installment_2_price: "",
        installment_3_price: "",
        paid_1: false,
        paid_2: false,
        paid_3: false,
      },
    };
  },
  computed: {
    calculateTotal() {
      let inspect_price = 0;
      if (this.model.is_inspected && this.model.car_type === "car")
        inspect_price = 200;
      else if (
        this.model.is_inspected &&
        this.model.car_type === "motorcycle"
      ) {
        inspect_price = 60;
      }

      return (
        Number(this.model.wsu_price) +
        Number(this.model.insurance_price) +
        Number(this.model.tax_price) +
        Number(inspect_price) +
        Number(this.model.other_price)
      );
    },
    calculateInstallment() {
      return (
        Number(this.model.installment_1_price) +
        Number(this.model.installment_2_price) +
        Number(this.model.installment_3_price)
      );
    },
  },
  methods: {
    loadReceipt: function() {
      var localApp = this;
      axios
        .get("/api/receipt/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.model = response.data.data;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    saveReceipt: function() {
      var localApp = this;
      axios
        .patch(
          "/api/receipt/" + this.$route.params.id,
          localApp.model,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            router.push("/receipt");
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    // deleteReceipt: function() {
    //   axios
    //     .delete("/api/receipt/" + this.$route.params.id, {
    //       headers: {
    //         Authorization: "Bearer " + localStorage.token,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 204) {
    //         router.push("/receipt");
    //       }
    //     })
    //     .catch(function(error) {
    //       alert(error);
    //     });
    // },
    getInsuranceType: function() {
      var localApp = this;
      axios
        .get("/api/master/insuranceType", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterInsuranceType = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getInsuranceTCompany: function() {
      var localApp = this;
      axios
        .get("/api/master/insuranceCompany", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterInsuranceCompany = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getBrand: function() {
      var localApp = this;
      axios
        .get("/api/master/brand", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterBrand = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getProvince: function() {
      var localApp = this;
      axios
        .get("/api/master/province", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterProvince = response.data.data;

            localApp.selectedLicensePlateProvince = localApp.masterProvince.findIndex(
              (item) => item.id === localApp.model.license_plate_province
            );
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectInsuranceType: function(id, name) {
      var localApp = this;

      localApp.model.insurance_type = id;
      localApp.model.insurance_type_name = name;
    },
    selectInsuranceCompany: function(id, name, fullname) {
      var localApp = this;

      localApp.model.insurance_company = id;
      localApp.model.insurance_company_name = name;
      localApp.model.insurance_company_fullname = fullname;
    },
    selectBrand: function(id, name) {
      var localApp = this;

      localApp.model.brand = id;
      localApp.model.brand_name = name;
    },
    selectLicensePlateProvince: function(id, index) {
      var localApp = this;
      localApp.selectedLicensePlateProvince = index;
      localApp.model.license_plate_province = id;
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadReceipt();
      this.getInsuranceType();
      this.getInsuranceTCompany();
      this.getBrand();
      this.getProvince();
    }
  },
};
</script>
<style>
h4 {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
.dropdown-menu {
  max-height: 300px !important;
  overflow-y: auto;
}
.form-control,
.btn {
  font-size: 1rem !important;
}
.form-control-label,
.custom-control-label {
  color: #525f7f;
  font-size: 1.05rem;
  font-weight: 600;
}
h3 {
  font-size: 1.2rem;
}
</style>
